import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Breadcrumbs, Card, ConfirmButtons, Input } from '../../../../components/UI/ComponentsUI';
import ContainerService from '../../../../services/ContainerService';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { isNullOrEmpty, showMessageToastCustom, translate } from '../../../../utils/util';
import SelectNew from '../../../../components/UI/SelectNew';
import { ENUMS } from '../../../../utils/constants';

const CoveragePartNumberInsert = (props) => {
    const update = props.location?.state?.update;
    const [data, setData] = useState(props.location?.state?.update && props.coveragePartNumber
        ? props.coveragePartNumber
        : { lineBorderType: 1 });

    const onChange = (event) => {
        onValueChange(event, data, setData);
    };

    const onConfirm = () => {
        if (validateInputsRequired()) {
            if (update) {
                props.update(data, (response) => {
                    if (response) {
                        props.history.go(-1);
                    }
                });
            }
            else {
                props.insert(data, (response) => {
                    if (response) {
                        props.history.go(-1);
                    }
                });
            }
        }
    };

    const getPartNumber = (partNumber) => {
        props.getPartNumber(partNumber, (response) => {
            if (response) {
                data.code = partNumber;
                data.description = response.description;
                setData({ ...data });
            } else {
                showMessageToastCustom(translate('warning', 'general'), "PN não encontrado", 3000, 'mdi mdi-alert-circle-outline red-text');
            }
        });
    }

    const onBlurPartNumber = (ev) => {
        if (!isNullOrEmpty(ev.currentTarget.value)) {
            ev.preventDefault();
            getPartNumber(ev.currentTarget.value)
        }
    }

    const calcCobertura = (stockFinal, needToday) => {
        var calc = (needToday || 0) === 0 ? 0.0 : Number(parseInt(stockFinal || 0) / parseInt(needToday || 0)).toFixed(1);
        data.coverage = calc;
        setData({ ...data })
    }

    return (
        <div>
            <Breadcrumbs id="unloadLocationInsert" title={{
                icon: "mdi mdi-view-dashboard-outline",
                label: "Parametrização do PN"
            }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <Card>
                        <div className="row" style={{ marginBottom: '0px' }}>
                            <div className="input-field no-padding  col l4 s4">
                                <Input
                                    required
                                    disabled={update}
                                    maxLength="11"
                                    label="Código"
                                    id="code"
                                    name="code"
                                    type="text"
                                    onBlur={(ev) => { onBlurPartNumber(ev); }}
                                    defaultValue={data?.code} />
                            </div>
                            <div className="input-field no-padding  col l4 s4">
                                <Input
                                    disabled
                                    required
                                    label="Descrição"
                                    id="description"
                                    name="description"
                                    type="text"
                                    onChange={onChange}
                                    value={data?.description} />
                            </div>
                            <div className="input-field no-padding  col l3 s3">
                                <Input
                                    required
                                    disabled={update}
                                    maxLength="8"
                                    label="Cod. Appro"
                                    id="supplierCode"
                                    name="supplierCode"
                                    type="text"
                                    onChange={onChange}
                                    value={data?.supplierCode} />
                            </div>
                            <div className="input-field no-padding  col l4 s4">
                                <Input
                                    required
                                    maxLength="20"
                                    label="Nom. Appro."
                                    id="supplierName"
                                    name="supplierName"
                                    type="text"
                                    onChange={onChange}
                                    value={data?.supplierName} />
                            </div>
                            <div className="input-field no-padding  col l4 s4">
                                <SelectNew
                                    required
                                    default
                                    id='lineBorder'
                                    name="lineBorder"
                                    label="BDL"
                                    value={data?.lineBorder || ''}
                                    placeHolder={translate('choose-one-option', 'general')}
                                    data={[
                                        { id: ENUMS.eLineBorder.Automatic.value, text: ENUMS.eLineBorder.Automatic.text },
                                        { id: ENUMS.eLineBorder.Manual.value, text: ENUMS.eLineBorder.Manual.text },
                                    ]}
                                    change={onChange}
                                />
                            </div>
                            {
                                parseInt(data.lineBorder || 0) === parseInt(ENUMS.eLineBorder.Automatic.value) ?
                                    <div className="input-field no-padding  col l3 s3">
                                        <SelectNew
                                            default
                                            required
                                            id='lineBorderType'
                                            name="lineBorderType"
                                            label="Tipo BDL"
                                            placeHolder={translate('choose-one-option', 'general')}
                                            data={[
                                                { id: ENUMS.eLineBorderType.AD.value, text: ENUMS.eLineBorderType.AD.text },
                                                { id: ENUMS.eLineBorderType.A.value, text: ENUMS.eLineBorderType.A.text },
                                                { id: ENUMS.eLineBorderType.D.value, text: ENUMS.eLineBorderType.D.text },
                                            ]}
                                            change={onChange}
                                            value={data?.lineBorderType}
                                        />
                                    </div> : data.lineBorder === ENUMS.eLineBorder.Manual.value.toString() &&
                                    <div className="row" style={{ marginBottom: '0px' }}>
                                        <div className="input-field no-padding  col l3 s3">
                                            <Input
                                                required
                                                max="8"
                                                label="Stock BDL"
                                                id="stockLineBorder"
                                                name="stockLineBorder"
                                                type="number"
                                                onChange={onChange}
                                                value={data?.stockLineBorder} />
                                        </div>
                                        <div className="input-field no-padding  col l4 s4">
                                            <Input
                                                required
                                                label="Hora BDL"
                                                id="hourLineBorder"
                                                name="hourLineBorder"
                                                type="time"
                                                onChange={onChange}
                                                className="center"
                                                value={data?.hourLineBorder} />
                                        </div>
                                    </div>
                            }

                        </div>
                        <div className="row" style={{ marginBottom: '0px' }}>
                            <div className="input-field no-padding  col l4 s4">
                                <Input
                                    required
                                    max="6"
                                    label="Stock Final"
                                    id="finalStock"
                                    name="finalStock"
                                    type="number"
                                    onChange={(evt) => {
                                        onChange(evt);
                                        calcCobertura(evt.currentTarget.value, data?.needToday)
                                    }}
                                    value={data?.finalStock} />
                            </div>
                            <div className="input-field no-padding  col l4 s4">
                                <Input
                                    required
                                    max="9"
                                    label="Neces. Hoje"
                                    id="needToday"
                                    name="needToday"
                                    type="number"
                                    onChange={(evt) => {
                                        onChange(evt);
                                        calcCobertura(data?.finalStock, evt.currentTarget.value,)
                                    }}
                                    value={data?.needToday} />
                            </div>
                            <div className="input-field no-padding  col l3 s3">
                                <Input
                                    required
                                    max="4"
                                    label="Cobertura"
                                    id="coverage"
                                    name="coverage"
                                    type="number"
                                    onChange={onChange}
                                    value={data?.coverage} />
                            </div>
                        </div>

                        <div className="row" style={{ marginBottom: '0px' }}>
                            <div className="input-field no-padding  col l4 s4">
                                <Input
                                    required
                                    max="6"
                                    label="Stock SENS2"
                                    id="stockSens"
                                    name="stockSens"
                                    type="number"
                                    onChange={onChange}
                                    value={data?.stockSens} />
                            </div>
                            <div className="input-field no-padding  col l4 s4">
                                <Input
                                    required
                                    max="6"
                                    label="Dotação"
                                    id="allocation"
                                    name="allocation"
                                    type="number"
                                    onChange={onChange}
                                    value={data?.allocation} />
                            </div>
                            <div className="input-field no-padding  col l3 s3">
                                <Input
                                    required
                                    max="6"
                                    label="Segurança"
                                    id="security"
                                    name="security"
                                    type="number"
                                    onChange={onChange}
                                    value={data?.security} />
                            </div>
                            <div className="input-field no-padding  col l4 s4">
                                <Input
                                    type="checkbox"
                                    onChange={onChange}
                                    checked={data.automaticLow}
                                    id="automaticLow"
                                    label="Baixa Aut"
                                    name="automaticLow"
                                />
                                <Input
                                    type="checkbox"
                                    onChange={onChange}
                                    checked={data.partsSensible}
                                    id="partsSensible"
                                    label="Pça Sensível"
                                    name="partsSensible"
                                />
                                <Input
                                    type="checkbox"
                                    onChange={onChange}
                                    checked={data.pgm}
                                    id="pgm"
                                    label="PGM"
                                    name="pgm"
                                />
                            </div>

                        </div>


                        <ConfirmButtons
                            onConfirm={() => onConfirm()}
                            onCancel={() => props.history.goBack()} />
                    </Card>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        coveragePartNumber: state.containerReducer.coveragePartNumber,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        insert: (unloadlocation, callback) => {
            dispatch(ContainerService.insertCoveragePartNumber(unloadlocation, callback));
        },
        update: (unloadlocation, callback) => {
            dispatch(ContainerService.updateCoveragePartNumber(unloadlocation, callback));
        },
        getPartNumber: (code, callback) => {
            dispatch(ContainerService.getPartNumberCoverage(code, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CoveragePartNumberInsert)));
